import { makeStyles } from "@mui/styles";
import { COLORS } from "../../constant/colors";

const useStyles = makeStyles((theme) => ({
  scrollTopButton: {
    position: "fixed",
    bottom: 30,
    right: 30,
    width: 40,
    height: 40,
    background: COLORS.primary,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    boxShadow: "0px 0px 15px rgba(0,0,0,0.3)",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    opacity: 0,
    borderRadius: "50%",
    visibility: "hidden",
    zIndex: 10,
    '@media (max-width: 500px)': {
      bottom: 20,
      right: 20,
    }
  },
  scrollTopButtonActive: {
    opacity: 1,
    visibility: "visible",
  },
  icon: {
    color: COLORS.white,
    fontSize: 25,
  },
}));

export default useStyles;
